import React, { useState } from 'react';
import { useQuery, useLazyQuery } from '@apollo/client';
import { GET_REWARD_SEQUENCES, GET_REWARDS_BY_SEQUENCE } from '../../graphql/RewardsGQL';
import Loading from '../../components/Loading';
import Sidebar from '../../components/Sidebar';
import RewardDetailsModal from './RewardDetailsModal';

const RewardSequencesTable: React.FC = () => {
  const { data, loading, error } = useQuery(GET_REWARD_SEQUENCES);

  const [selectedSequenceId, setSelectedSequenceId] = useState<string | null>(null);
  const [modalOpen, setModalOpen] = useState(false);

  const [fetchRewardDetails, { data: rewardDetailsData, loading: rewardLoading }] =
    useLazyQuery(GET_REWARDS_BY_SEQUENCE);

  const handleOpenModal = (sequenceId: string) => {
    setSelectedSequenceId(sequenceId);
    fetchRewardDetails({ variables: { sequenceId } });
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedSequenceId(null);
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', backgroundColor: '#FFFCFB' }}>
      <Sidebar isOpen={true} setIsOpen={() => {}} />
      <main style={{ flex: 1, marginLeft: '250px', padding: '30px 20px', overflowX: 'hidden' }}>
        <br/><br/>
        <h1 style={{ marginBottom: '20px', fontSize: '1.8rem' }}>Reward Sequences</h1>

        {loading ? (
          <Loading />
        ) : error ? (
          <p style={{ color: 'red' }}>Error loading reward sequences</p>
        ) : (
          <div style={{ width: '100%', overflowX: 'auto', background: '#fff', borderRadius: 10 }}>
            <table style={{ width: '100%', minWidth: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ backgroundColor: '#FFF8F6' }}>
                  <th
                    style={{
                      position: 'sticky',
                      left: 0,
                      background: '#FFF8F6',
                      zIndex: 2,
                      padding: '12px',
                      border: '1px solid #eee',
                      textAlign: 'left',
                      fontWeight: 700,
                      color: '#FF5722',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    Sequence ID
                  </th>
                  {Array.from({ length: 28 }, (_, i) => (
                    <th key={i} style={{ padding: '10px', border: '1px solid #eee', whiteSpace: 'nowrap' }}>
                      S{i + 1}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data?.rewardSequences.map((seq: any) => (
                  <tr key={seq.sequenceID}>
                    <td
                      style={{
                        position: 'sticky',
                        left: 0,
                        background: '#fff',
                        zIndex: 1,
                        padding: '10px',
                        border: '1px solid #eee',
                        fontWeight: 600,
                        cursor: 'pointer',
                        color: '#FF5722',
                        textDecoration: 'underline',
                      }}
                      onClick={() => handleOpenModal(seq.sequenceID)}
                    >
                      {seq.sequenceID}
                    </td>
                    {Array.from({ length: 28 }, (_, i) => (
                      <td
                        key={i}
                        style={{
                          padding: '8px 10px',
                          border: '1px solid #f0f0f0',
                          textAlign: 'center',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {seq[`step_${i + 1}`]}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <RewardDetailsModal
          isOpen={modalOpen}
          onClose={handleCloseModal}
          rewards={rewardDetailsData?.getRewardsBySequence || []}
          loading={rewardLoading}
        />
      </main>
    </div>
  );
};

export default RewardSequencesTable;
